import { render, staticRenderFns } from "./shopManagement.vue?vue&type=template&id=9420310a&scoped=true&"
import script from "./shopManagement.vue?vue&type=script&lang=js&"
export * from "./shopManagement.vue?vue&type=script&lang=js&"
import style0 from "./shopManagement.vue?vue&type=style&index=0&id=9420310a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9420310a",
  null
  
)

export default component.exports